import React, { Fragment, useEffect, useRef, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { InputText } from "primereact/inputtext";
import { Steps } from 'primereact/steps';
import { Dropdown } from 'primereact/dropdown';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';

import Draggable from 'react-draggable';
import { FormatDisplay, ToastService, useDataTableBasic, useDialogCrup, useForm } from '@iamsoftware/react-hooks';

import { AgreementService as Service } from './AgreementService';
import { AgreementTemplateService } from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';
import { ProductService } from '../../danh-muc/san-pham/ProductService';
import { CommonService } from '../../../service/CommonService';
import { CustomerService } from '../../danh-muc/khach-hang/CustomerService';
import { Crup } from './Crup';
import "pdfjs-dist/build/pdf.worker.mjs";
import { getDocument } from 'pdfjs-dist';
import { AppStorage } from '../../../service/UserStorage';

export const NewAgreement = ({ display, setDisplay, reloadLazyData }) => {
  const ref = useRef(null);
  const nodeRef = useRef(null);
  const [useTemplateAgreement, setUseTemplateAgreement] = useState('N');
  const [agreementTemplate, setAgreementTemplate] = useState([]);
  const [products, setProducts] = useState([]);
  const [agreementNoInt, setAgreementNoInt] = useState('');
  const [agreementNo, setAgreementNo] = useState('');
  const [agreementContentId, setAgreementContentId] = useState('');
  const [agreementFileName, setAgreementFileName] = useState('');
  const [displayCrup, setDisplayCrup] = useState(null);
  const [displayFile, setDisplayFile] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [agreementSignatureParties, setAgreementSignatureParties] = useState([]);
  const [inputFile, setInputFile] = useState(null)
  const [displayFormFields, setDisplayFormFields] = useState(null)
  const [dbFormFields, setDbFormFields] = useState([]);
  const [savedDbFormFields, setSavedDbFormFields] = useState([]); // Lưu dữ liệu mapping khi chuyển step
  const [useTemplate, setUseTemplate] = useState(false)
  const [deleteAgreementParties, setDeleteAgreementParties] = useState([])
  const [deleteSignatureLocations, setDeleteSignatureLocations] = useState([])
  const [agreementTotal, setAgreementTotal] = useState(null)
  const [changeTemplate, setChangeTemplate] = useState(false)
  const [loading, setLoading] = useState(true); // Initialize loading state
  const optionCheck = [
    { value: 'Y', label: 'Tích chọn' },
    { value: 'N', label: 'Không tích' }
  ]
  const [agreementParties, setAgreementParties] = useState([{
    party: null,
    partyId: '',
    taxCode: '',
    partyName: '',
    emailAddress: '',
    contactNumber: '',
    representativeName: '',
    identityCard: '',
    roleTypeId: ''
  }])
  useEffect(() => {
    if (display) {
      setAgreementFileName('')
      // Xóa dữ liệu mapping đã lưu khi bắt đầu tạo hợp đồng mới
      setSavedDbFormFields([]);
      AgreementTemplateService.getAgreementList('N', '').then(data => {
        setAgreementTemplate(data.listData.map(item => {
          return { value: item.agreementId, label: `[${item.agreementPseudoId}]-${item.agreementName}` };
        }))
      })
    }
    if (display?.agreementId) {
      setAgreementNo(display?.agreementNo)
      setAgreementTotal(display?.agreementTotal)
      if (display?.agreementDate) {
        display.agreementDate = FormatDisplay.date(new Date(display.agreementDate), 'YYYY-MM-DD');
      }
      if (display?.productId) {
        ProductService.get(display.productId).then(data => {
          display.product = { ...data, value: data.productId, label: `[${data.pseudoId}] - ${data.productName}` };
          productInfoForm.setValue(display)

        })
      }
      if (display?.useTemplateAgreement === 'N') {
        setUseTemplateAgreement('N')
        setInputFile(display?.agreementContentId)
      } else if (display?.useTemplateAgreement === 'Y') {
        setUseTemplateAgreement('Y')
        setInputFile({
          "templateAgreementId": commonInfo.templateAgreementId,
          "dbFormFields": dbFormFields
        })
      }
      setAgreementFileName(display.agreementFileName)
      setAgreementContentId(display?.agreementContentId)
      commonInfoForm.setValue(display)
      setAgreementParties(display.agreementParties)
    }
    if (display === true) {
      commonInfoForm.reset();
      productInfoForm.reset();
      setAgreementNo('')
      setAgreementTotal(null)
      setAgreementFileName('')
      commonInfoForm.setValue({ agreementDate: (FormatDisplay.date(new Date(Date.now()), 'YYYY-MM-DD')) })
    }
    if (!display) {
      setChangeTemplate(false)
      setAgreementNo('')
      setDbFormFields([])
      setAgreementTotal(null)
      setAgreementFileName('')
      commonInfoForm.reset();
      productInfoForm.reset();
      setActiveIndex(0)
      setAgreementSignatureParties([])
      setAgreementParties([{
        party: null,
        partyId: '',
        taxCode: '',
        partyName: '',
        emailAddress: '',
        contactNumber: '',
        representativeName: '',
        identityCard: '',
        roleTypeId: ''
      }])
    }
  }, [display]);
  const searchProducts = event => {
    ProductService.find(event.query).then(data => {
      setProducts(data.listData.map(item => {
        delete item.disabled;
        let label = `[${item.pseudoId}]- ${item.productName}`;
        return { ...item, value: item.productId, label: label }
      }))
    })
  }

  const { render: renderDialogCrup, create } = useDialogCrup({
    header: '! Upload File hợp đồng',
    width: '80rem',
    fields: [
      { field: 'contentFile', header: 'File hợp đồng', type: 'file', InputFileProps: { accept: '.pdf' }, className: 'md:col-12' },
    ],
    createItem: async item => {
      return Service.uploadDraft(await inject(item)).then(data => {
        setAgreementContentId(data.agreementContentId)
        setAgreementFileName(data.agreementFileName)
        setDisplayCrup(data.agreementContentId)
      });
    },

    useSaveSplitButton: false
  });

  const inject = async item => {
    if (item.contentFile.length) {
      const file = item.contentFile[0];

      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        ToastService.error('File quá lớn. Kích thước tối đa là 10MB.');
        throw new Error('File too large');
      }

      // Validate file type
      if (file.type !== 'application/pdf') {
        ToastService.error('Chỉ chấp nhận file PDF.');
        throw new Error('Invalid file type');
      }

      item.contentFile = file;
    }
    return Service.toFormData(item)
  }

  const commonInfoForm = useForm({
    fields: [
      {
        field: 'templateAgreementId', header: 'Mẫu hợp đồng', required: true, type: 'Dropdown', DropdownProps: { options: agreementTemplate }, className: 'md:col-3 xxx', displayDependency(): boolean {
          return useTemplateAgreement === 'Y'
        }, disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'contentFile', header: 'File hợp đồng', type: 'file', className: 'md:col-3 xxx', InputFileProps: { accept: '.pdf' }, displayDependency(): boolean {
          return (useTemplateAgreement === 'N' && display === true)
        }
      },
      {
        className: 'md:col-3  xxx', type: 'custom',
        body: <div>
          <div>
            <div>
              File hợp đồng<span style={{ color: 'red' }}>*</span>
            </div>
            <div className='p-inputgroup mt-2'>
              <InputText value={agreementFileName} disabled />
              <span className="p-inputgroup-addon" style={{ background: '#22C55E', color: 'white', cursor: 'pointer' }} onClick={() => displayAgreementFile()}>
                <i className="pi pi-eye" />
              </span>
              <span className="p-inputgroup-addon" style={{ background: '#F59E0B', color: 'white', cursor: 'pointer' }} onClick={() => create()}>
                <i className="pi pi-pencil" />
              </span>
            </div>
          </div>
        </div>
        , displayDependency(): boolean {
          return (display !== true && useTemplateAgreement === 'N')
        },
      },
      {
        type: 'custom', body:
          <div className="flex flex-wrap gap-3" style={{ marginTop: '25px' }}>
            <div className="flex align-items-center ">
              <RadioButton size={1} inputId="option1" value="Y" onChange={(e) => handleTemplateAgreementChange(e.value)} checked={useTemplateAgreement === 'Y'} disabled={display?.doView === true} />
              <label htmlFor="option1" className="ml-2">Sử dụng mẫu</label>
            </div>
            <div className="flex align-items-center">
              <RadioButton inputId="option2" value="N" onChange={(e) => handleTemplateAgreementChange(e.value)} checked={useTemplateAgreement === 'N'} disabled={display?.doView === true} />
              <label htmlFor="option2" className="ml-2">Không sử dụng</label>
            </div>
          </div>, className: 'md:col-3 xxx'
      },
      {
        className: 'md:col-3  xxx ', type: 'custom',
        body: <div>
          <div>
            <div>
              Số hợp đồng<span style={{ color: 'red' }}>*</span>
            </div>
            <div className='p-inputgroup mt-2'>
              <InputText value={agreementNo} onChange={(e) => {
                setAgreementNo(e.target.value)
              }} disabled={display?.doView === true} />
              <span className="p-inputgroup-addon" style={{ background: 'blue', color: 'white', cursor: 'pointer' }}>
                <i className="pi pi-sync" onClick={() => getAgreementNo()} />
              </span>
            </div>
          </div>
        </div>
      },
      {
        field: 'agreementDate', header: 'Ngày hợp đồng', InputTextProps: { type: 'date' }, className: 'md:col-3 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'agreementSubTotal', header: 'Tổng tiền trước thuế', type: 'InputNumber', InputNumberProps: { min: 0, onBlur: () => recalcTotals() }, className: 'md:col-2 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'agreementTaxTotal', header: 'Tiền thuế', type: 'InputNumber', InputNumberProps: { min: 0, onBlur: () => recalcTotals() }, className: 'md:col-2 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        className: 'md:col-2  xxx ', type: 'custom',
        body: <div>
          <div>
            <div>
              Giá trị hợp đồng
            </div>
            <div className='p-inputgroup mt-2'>
              <InputNumber value={agreementTotal} onChange={e => setAgreementTotal(e.value)} locale="de-DE" onBlur={() => { amountToWords(); recalcTotals(); }}
                min={0} disabled={display?.doView === true} />
            </div>
          </div>
        </div>
      },
      {
        field: 'amountInWords', header: 'Số tiền bằng chữ', className: 'md:col-6 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'description', header: 'Ghi chú', className: 'md:col-12 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },

    ]
  });
  const productInfoForm = useForm({
    fields: [
      {
        field: 'product', header: 'Sản phẩm/Dịch vụ', type: 'AutoComplete',
        AutoCompleteProps: { suggestions: products, completeMethod: searchProducts, field: 'label', dropdown: true, placeholder: 'Tìm theo tên sản phẩm', }, className: 'md:col-6 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'unitAmount', header: 'Đơn giá', type: 'InputNumber', InputNumberProps: { min: 0, max: 999999999999 }, className: 'md:col-2 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'quantity', header: 'Số lượng', type: 'InputNumber', InputNumberProps: { min: 0, max: 999999 }, className: 'md:col-2 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'taxPercentage', header: '% Thuế', type: 'InputNumber', disabled: true, InputNumberProps: { suffix: '%', min: 0, max: 100 }, className: 'md:col-2 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'amount', header: 'Thành tiền', type: 'InputNumber', disabled: true, InputNumberProps: { min: 0, max: 999999999999 }, className: 'md:col-3 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'taxTotal', header: 'Tiền thuế', type: 'InputNumber', disabled: true, InputNumberProps: { min: 0, max: 999999999999 }, className: 'md:col-3 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
      {
        field: 'amountTotal', header: 'Tổng cộng', type: 'InputNumber', disabled: true, InputNumberProps: { min: 0, max: 999999999999 }, className: 'md:col-6 xxx', disabledDependency(): boolean {
          return display?.doView === true
        }
      },
    ]
  });

  const commonInfo = commonInfoForm.getRawValue();
  const productInfo = productInfoForm.getRawValue();

  const amountToWords = () => {
    if (agreementTotal) {
      CommonService.amountToWords(agreementTotal).then(data => {
        commonInfo.amountInWords = data.amountInWords
        commonInfoForm.setValue(commonInfo)
      })
    }
  }

  // Tính toán lại tổng tiền và cập nhật vào form mapping
  const recalcTotals = (partial?: any) => {
    const current = commonInfoForm.getRawValue() || {};
    const next = { ...current, ...(partial || {}) };
    const sub = Number(next.agreementSubTotal || 0);
    const tax = Number(next.agreementTaxTotal || 0);
    const total = sub + tax;
    setAgreementTotal(total);
    next.agreementTotal = total;
    commonInfoForm.setValue(next);
    if (total && total > 0) {
      CommonService.amountToWords(total).then(data => {
        const updated = { ...next, amountInWords: data.amountInWords };
        commonInfoForm.setValue(updated);
      });
    }
  }

  useEffect(() => {
    if (productInfo.product) {
      if (productInfo.product.taxInPrice === "Y") {
        productInfo.unitAmount = productInfo.product.price - productInfo.product.taxAmount
        productInfo.taxPercentage = productInfo.product.taxPercentage
        productInfo.quantity = 1
        productInfo.amount = productInfo.unitAmount
        productInfo.taxTotal = productInfo.product.taxAmount
        productInfo.amountTotal = productInfo.amount + productInfo.product.taxAmount
        productInfoForm.setValue(productInfo)
      } else {
        productInfo.unitAmount = productInfo.product.price
        productInfo.taxPercentage = productInfo.product.taxPercentage
        productInfo.quantity = 1
        productInfo.amount = productInfo.product.price
        productInfo.taxTotal = productInfo.product.price * productInfo.product.taxPercentage / 100
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      }

    }
  }, [productInfo.product])
  // Tự động tính toán khi thay đổi số lượng
  useEffect(() => {
    if (productInfoForm.dirty['quantity'] && productInfo.quantity) {
      if (productInfo.product && productInfo.product.taxInPrice === "Y") {
        productInfo.unitAmount = productInfo.product.price - productInfo.product.taxAmount
        productInfo.amount = productInfo.unitAmount * productInfo.quantity
        productInfo.taxTotal = productInfo.product.taxAmount * productInfo.quantity
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      } else {
        productInfo.amount = productInfo.unitAmount * productInfo.quantity
        productInfo.taxTotal = productInfo.unitAmount * productInfo.product.taxPercentage * productInfo.quantity / 100
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      }
    }
  }, [productInfo.quantity])

  // Tự động tính toán khi thay đổi đơn giá
  useEffect(() => {
    if (productInfoForm.dirty['unitAmount'] && productInfo.unitAmount && productInfo.quantity) {
      if (productInfo.product && productInfo.product.taxInPrice === "Y") {
        // Thuế đã bao trong giá
        productInfo.amount = productInfo.unitAmount * productInfo.quantity
        productInfo.taxTotal = productInfo.product.taxAmount * productInfo.quantity
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      } else {
        // Thuế chưa bao trong giá
        productInfo.amount = productInfo.unitAmount * productInfo.quantity
        productInfo.taxTotal = productInfo.unitAmount * productInfo.taxPercentage * productInfo.quantity / 100
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      }
    }
  }, [productInfo.unitAmount])

  // Tự động tính toán khi thay đổi % thuế
  useEffect(() => {
    if (productInfoForm.dirty['taxPercentage'] && productInfo.taxPercentage && productInfo.unitAmount && productInfo.quantity) {
      if (productInfo.product && productInfo.product.taxInPrice !== "Y") {
        // Chỉ tính lại khi thuế chưa bao trong giá
        productInfo.amount = productInfo.unitAmount * productInfo.quantity
        productInfo.taxTotal = productInfo.unitAmount * productInfo.taxPercentage * productInfo.quantity / 100
        productInfo.amountTotal = productInfo.amount + productInfo.taxTotal
        productInfoForm.setValue(productInfo)
      }
    }
  }, [productInfo.taxPercentage])

  useEffect(() => {
    if (commonInfoForm.dirty['templateAgreementId'] && commonInfo.templateAgreementId) {
      getAgreementNo()
    }
    if (commonInfo.templateAgreementId) {
      if (ref.current && ref.current !== commonInfo.templateAgreementId) {
        setChangeTemplate(true)
      } else {
        if (commonInfoForm.dirty['templateAgreementId']) {
          ref.current = commonInfo?.templateAgreementId
        }
      }
    }
  }, [commonInfo.templateAgreementId])
  useEffect(() => {
    if (agreementTotal) {
      setChangeTemplate(true)
    }
  }, [agreementTotal])
  const getAgreementNo = () => {
    if (commonInfo.templateAgreementId) {
      Service.agreementSequence(commonInfo.templateAgreementId).then(data => {
        commonInfo.agreementNo = data.agreementNo
        setAgreementNo(data.agreementNo)
        setAgreementNoInt(data.agreementNoInt)
        commonInfoForm.setValue(commonInfo)
      })
    }
  }

  const handleTemplateAgreementChange = (value) => {
    setUseTemplateAgreement(value)

    // Reset template-related states when switching to "Không sử dụng mẫu"
    if (value === 'N') {
      setUseTemplate(false)
      setDbFormFields([])
      setDisplayFormFields(false)
      setChangeTemplate(false)
      // Clear template selection
      commonInfo.templateAgreementId = null
      commonInfoForm.setValue(commonInfo)
    }
  }
  const displayAgreementFile = () => {
    if (agreementContentId) {
      setDisplayFile(Date.now())
    }
  }
  const injectCreating = item => {
    if (item.contentFile.length) {
      item.contentFile = item.contentFile[0]
    }
    if (agreementContentId) {
      item.agreementContentId = agreementContentId
    }
    if (display?.agreementId) {
      item.deleteAgreementParties = JSON.stringify(deleteAgreementParties)
      item.deleteSignatureLocations = JSON.stringify(deleteSignatureLocations)
    }
    if (dbFormFields) {
      item.dbFormFields = JSON.stringify(dbFormFields)
    }
    item.productId = item.product.productId
    return Service.toFormData(item);
  }

  const onSubmit = async () => {
    const data = Object.assign(commonInfo, productInfo)
    data.agreementNoInt = agreementNoInt
    data.agreementNo = agreementNo
    data.agreementTotal = agreementTotal
    agreementParties.map(agreementParty => {
      delete agreementParty.party
    })
    if (commonInfoForm.valid() && productInfoForm.valid()) {
      data.useTemplateAgreement = useTemplateAgreement
      data.agreementParties = JSON.stringify(agreementParties)
      data.agreementSignatureParties = JSON.stringify(agreementSignatureParties)
      if (agreementSignatureParties.length > 0) {
        try {
          if (display?.agreementId) {
            const response = await Service.update(display?.agreementId, await injectCreating(data));
            if (response?.success === 'N') {
              ToastService.error(response?.message || 'Có lỗi xảy ra khi cập nhật hợp đồng.');
              return;
            }
            ToastService.success();
            reloadLazyData();
            setDisplay(false);
            // Xóa dữ liệu mapping đã lưu khi hoàn thành thành công
            setSavedDbFormFields([]);
          } else {
            const response = await Service.create(await injectCreating(data));
            if (response?.success === 'N') {
              ToastService.error(response?.message || 'Có lỗi xảy ra khi tạo hợp đồng.');
              return;
            }
            ToastService.success();
            reloadLazyData();
            setDisplay(false);
            // Xóa dữ liệu mapping đã lưu khi hoàn thành thành công
            setSavedDbFormFields([]);
          }
        } catch (error) {
          console.error('Error creating/updating agreement:', error);
          ToastService.error('Có lỗi xảy ra khi tạo/cập nhật hợp đồng. Vui lòng thử lại.');
        }
      } else {
        ToastService.error('Chưa cấu hình vị trí ký trên hợp đồng')
      }

    } else {
      ToastService.error()
    }
  }

  const nextStep = () => {

    if (activeIndex === 0) {
      if (!commonInfo.templateAgreementId && !commonInfo.contentFile && !agreementContentId) {
        ToastService.error('Chưa chọn mẫu hợp đồng hoặc tải lên file hợp đồng')
      } else if (!agreementNo) {
        ToastService.error('Số hợp đồng không được bỏ trống')
      } else if (commonInfo.templateAgreementId) {
        if (changeTemplate === true) {
          const data = Object.assign(commonInfo, productInfo)
          data.agreementNo = agreementNo
          data.agreementTotal = agreementTotal
          if (display?.agreementId) {
            data.forAgreementId = display?.agreementId
          }
          Service.fillPlaceholder(data).then(db => {
            // Nếu có dữ liệu đã lưu, khôi phục lại thay vì dùng dữ liệu mới
            if (savedDbFormFields.length > 0) {
              setDbFormFields(savedDbFormFields);
            } else {
              setDbFormFields(db.dbFormFields.map(field => {
                field.isRequired = field.isRequired === 'Y';
                if (field.fieldTypeEnumId === "DBFFAT_date-short" || field.fieldTypeEnumId === "DBFFAT_date-long") {
                  if (field.value) {
                    const parsed = new Date(parseInt(field.value));
                    field.value = isNaN(parsed.getTime()) ? '' : FormatDisplay.date(parsed, 'YYYY-MM-DD');
                  } else {
                    field.value = '';
                  }
                }
                return field;
              }));
            }
            if (db.dbFormFields.length === 0) {
              setActiveIndex(1)
            } else {
              setUseTemplate(true)
              setDisplayFormFields(Date.now())
            }
          })
        } else {
          if (dbFormFields.length > 0) {
            setUseTemplate(true)
            setDisplayFormFields(Date.now())
          } else {
            const data = Object.assign(commonInfo, productInfo)
            data.agreementNo = agreementNo
            if (display?.agreementId) {
              data.forAgreementId = display?.agreementId
            }
            data.agreementTotal = agreementTotal

            Service.fillPlaceholder(data).then(db => {

              setDbFormFields(db.dbFormFields.map(field => {
                field.isRequired = field.isRequired === 'Y';
                if (field.fieldTypeEnumId === "DBFFAT_date-short" || field.fieldTypeEnumId === "DBFFAT_date-long") {
                  if (field.value) {
                    const parsed = new Date(parseInt(field.value));
                    field.value = isNaN(parsed.getTime()) ? '' : FormatDisplay.date(parsed, 'YYYY-MM-DD');
                  } else {
                    field.value = '';
                  }
                }
                return field;
              }));
              if (db.dbFormFields.length === 0) {
                setInputFile({
                  "templateAgreementId": commonInfo.templateAgreementId,
                  "dbFormFields": dbFormFields
                })
                setActiveIndex(1)
              } else {
                setUseTemplate(true)
                setDisplayFormFields(Date.now())
              }
            })
          }
        }
      } else {
        // Reset template-related states when not using template
        setUseTemplate(false)
        setDbFormFields([])
        setDisplayFormFields(false)

        if (commonInfo?.contentFile) {
          setInputFile(commonInfo.contentFile[0])
          setActiveIndex(1)
        } else if (agreementContentId) {
          setActiveIndex(1)
        }
      }
    } else if (activeIndex === 1) {
      let checker = true
      let errorMessage = ''
      
      for (let i = 0; i < agreementParties.length; i++) {
        const item = agreementParties[i];
        
        if (!item.partyName) {
          checker = false
          errorMessage = 'Chưa chọn đối tượng ký'
          break
        }
        
        if (!item.emailAddress) {
          checker = false
          errorMessage = `Chưa nhập địa chỉ email cho ${item.partyName}`
          break
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(item.emailAddress)) {
          checker = false
          errorMessage = `Địa chỉ email của ${item.partyName} chưa nhập đúng định dạng`
          break
        }
        
        if (!item.roleTypeId) {
          checker = false
          errorMessage = `Chưa chọn vai trò người ký cho ${item.partyName}`
          break
        }
        
        // Validation mã số thuế
        if (item.taxCode && item.taxCode.length > 0 && ![10, 12, 13].includes(item.taxCode.length)) {
          checker = false
          errorMessage = `Mã số thuế của ${item.partyName} phải có 10, 12 hoặc 13 số`
          break
        }
        
        // Validation số điện thoại: đúng 10 số
        if (item.contactNumber && item.contactNumber.length > 0 && item.contactNumber.length !== 10) {
          checker = false
          errorMessage = `Số điện thoại của ${item.partyName} phải có đúng 10 số`
          break
        }
      }
      
      if (!checker && errorMessage) {
        ToastService.error(errorMessage)
      }
      
      if (checker === true) {
        setActiveIndex(activeIndex + 1)
      }
    } else if (activeIndex === 2) {
      setActiveIndex(activeIndex + 1)
    }
  }
  const backWard = () => {
    if (activeIndex === 1 && useTemplateAgreement === 'Y') {
      // Khi quay lại từ step 1 về step 0 và đang dùng mẫu hợp đồng
      // Khôi phục lại form mapping với dữ liệu đã nhập
      setDisplayFormFields(true);
      // Khôi phục dữ liệu mapping đã lưu
      if (savedDbFormFields.length > 0) {
        setDbFormFields(savedDbFormFields);
      }
    }
    setActiveIndex(activeIndex - 1)
    setLoading(true)
  }
  const onEditorChange = (rowData, column, newValue) => {
    setDbFormFields(prevItems => prevItems.map(prevItem => {
      if (prevItem['fieldName'] === rowData['fieldName']) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }
  const { render: renderDataTableItem } = useDataTableBasic({
    tableHeader: `Danh sách trường thông tin`,
    dataKey: 'fieldName',
    indexColumnWidth: 45,
    columns: [
      { field: 'title', header: 'Tên trường', minWidth: 200, sortable: false },
      { field: 'tooltip', header: 'Mô tả', minWidth: 200, sortable: false },
      { field: 'isRequired', header: 'Bắt buộc', width: 120, dataType: 'checkbox', sortable: false },
      { field: 'fieldTypeEnum', header: 'Kiểu dữ liệu', width: 280, sortable: false },
      {
        field: 'value', header: 'Dữ liệu đơn hàng HT', width: '30%', sortable: false,
        dataType: 'editor', getEditorConfig(rowData: any): any {
          switch (rowData.fieldTypeEnumId) {
            case 'DBFFAT_number':
              return { onEditorChange, field: { type: 'InputNumber' } };
            case 'DBFFAT_date-long':
            case 'DBFFAT_date-short':
              return { 
                onEditorChange, 
                field: { 
                  InputTextProps: { 
                    type: 'date',
                    max: useTemplateAgreement === 'Y' ? new Date().toISOString().split('T')[0] : undefined
                  } 
                } 
              };
            case 'DBFFAT_checkbox':
              return { onEditorChange, field: { type: 'Dropdown', DropdownProps: { options: optionCheck } } };
            default:
              return { onEditorChange, };
          }
        }
      }
    ],
    items: dbFormFields
  });
  const validate = () => {
    return new Promise<any[]>((resolve, reject) => {
      if (dbFormFields?.length) {
        if (dbFormFields.filter(it => it.isRequired === true && !it.value).length > 0) {
          reject();
          ToastService.error(`Các trường [${dbFormFields.filter(it => it.isRequired === true && !it.value).map(it => it.title).join(', ')}] chưa có dữ liệu.`);
        } else {
          // Kiểm tra ngày tương lai khi sử dụng mẫu hợp đồng
          if (useTemplateAgreement === 'Y') {
            const futureDateFields = dbFormFields.filter(it => {
              if ((it.fieldTypeEnumId === 'DBFFAT_date-long' || it.fieldTypeEnumId === 'DBFFAT_date-short') && it.value) {
                const inputDate = new Date(it.value);
                const today = new Date();
                today.setHours(23, 59, 59, 999); // Set to end of today
                return inputDate > today;
              }
              return false;
            });
            
            if (futureDateFields.length > 0) {
              reject();
              ToastService.error(`Không được phép nhập ngày tương lai cho các trường: [${futureDateFields.map(it => it.title).join(', ')}]`);
            } else {
          const payloadFields = dbFormFields.map(src => {
            const dbFormField = { ...src } as any;
            if (dbFormField.isRequired === true) dbFormField.isRequired = 'Y';
            if (dbFormField.isRequired === false) dbFormField.isRequired = 'N';
            if (dbFormField.fieldTypeEnumId === 'DBFFAT_date-long' || dbFormField.fieldTypeEnumId === 'DBFFAT_date-short') {
              if (dbFormField.value) {
                const dt = new Date(dbFormField.value);
                dbFormField.value = isNaN(dt.getTime()) ? '' : `${dt.getTime()}`;
              }
            }
            return dbFormField;
          });
          resolve(payloadFields);
            }
          } else {
            const payloadFields = dbFormFields.map(src => {
              const dbFormField = { ...src } as any;
              if (dbFormField.isRequired === true) dbFormField.isRequired = 'Y';
              if (dbFormField.isRequired === false) dbFormField.isRequired = 'N';
              if (dbFormField.fieldTypeEnumId === 'DBFFAT_date-long' || dbFormField.fieldTypeEnumId === 'DBFFAT_date-short') {
                if (dbFormField.value) {
                  const dt = new Date(dbFormField.value);
                  dbFormField.value = isNaN(dt.getTime()) ? '' : `${dt.getTime()}`;
                }
              }
              return dbFormField;
            });
            resolve(payloadFields);
          }
        }
      }
    });
  }
  const handleDbFormFields = () => {
    validate().then((payloadFields) => {
      // Lưu dữ liệu mapping trước khi chuyển step
      setSavedDbFormFields(dbFormFields);
      setInputFile({
        "templateAgreementId": commonInfo.templateAgreementId,
        "dbFormFields": payloadFields
      })
      setActiveIndex(1)
      setDisplayFormFields(false)
    }).catch((error) => {
      // Validation failed, keep the form open and don't lose data
      console.log('Validation failed:', error);
      // Don't change activeIndex or close displayFormFields
    })
  }

  const footer = (
    <div>
      <div>
        {(activeIndex === 1 || activeIndex === 2) && <Button label="Quay lại" icon="pi pi-arrow-circle-left" severity={'danger'} className="p-button-sm" type="button" onClick={() => backWard()} />}
        {(activeIndex === 0 || activeIndex === 1) && <Button label="Tiếp tục" icon="pi pi-arrow-circle-right" severity={'success'} className="p-button-sm" type="button" onClick={() => nextStep()} />}
        {activeIndex === 2 && <Button label="Hoàn thành" icon="pi pi-check" className="p-button-sm" type="button" onClick={() => onSubmit()} />}
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplay(false)} />
      </div>
    </div>
  );
  const fileFooter = (
    <div>
      {displayFile && <div>
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFile(false)} />
      </div>}
      {displayFormFields && <div>
        <Button label="Tiếp tục" icon="pi pi-angle-double-right" className="p-button-outlined p-button-success p-button-sm" type="button" onClick={() => handleDbFormFields()} />
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFormFields(false)} />
      </div>}
    </div>
  );
  const header = (
    <div>
      {display?.doView === true && <div>Chi tiết hợp đồng</div>}
      {display?.doView === false && <div>Cập nhật hợp đồng</div>}
      {display === true && <div>Tạo mới hợp đồng</div>}
    </div>
  );


  return (
    <Dialog header={header} footer={footer} visible={!!display} maximized={true} draggable={false} style={{ width: '100vw', height: '100vh' }} contentStyle={{ height: 'calc(100vh - 110px)' }} position="top" onHide={() => setDisplay(false)}>
      {loading === true && activeIndex === 2 && <div className={'loader'} style={{ width: '100%' }}>
      </div>}
      {(display?.doView === false || display === true) && (loading === false || activeIndex === 0 || activeIndex === 1) && <div className="card">
        <Steps model={steps} activeIndex={activeIndex} readOnly={false} />
      </div>}
      {(display?.doView === false || display === true) && activeIndex === 0 && <div className="grid mt-3">
        <div className="col-12">
          <Fieldset legend="Thông tin chung">
            {commonInfoForm.render()}
          </Fieldset>
          <Fieldset className='mt-2' legend="Sản phẩm/ dịch vụ">
            {productInfoForm.render()}
          </Fieldset>
        </div>
      </div>}
      {(display?.doView === false || display === true) && activeIndex === 1 && <AgreementParties agreementData={display} agreementParties={agreementParties} setAgreementParties={setAgreementParties} deleteAgreementParties={deleteAgreementParties} setDeleteAgreementParties={setDeleteAgreementParties}></AgreementParties>}
      {(display?.doView === false || display === true) && activeIndex === 2 && <DisplayCanvas loading={loading} setLoading={setLoading} useTemplate={useTemplate} agreementData={display} agreementParties={agreementParties} agreementSignatureParties={agreementSignatureParties} setAgreementSignatureParties={setAgreementSignatureParties} deleteSignatureLocations={deleteSignatureLocations} setDeleteSignatureLocations={setDeleteSignatureLocations} inputFile={inputFile}></DisplayCanvas>}
      <Crup agreementId={display?.agreementId} display={displayCrup} setDisplay={setDisplayCrup} setDisplayDialog={setDisplay} reloadLazyData={reloadLazyData} />
      {renderDialogCrup()}
      <Dialog header={`File hợp đồng - ${agreementFileName}`} maximized={true} draggable={false} footer={fileFooter} visible={!!displayFile} style={{ width: '80rem', height: '60rem', }} position="top" onHide={() => setDisplayFile(false)}>
        {agreementContentId &&
          <iframe src={`${Service.baseURL}/${Service.entity}/contents/${agreementContentId}/pdf?v=${Date.now()}`} title="Hợp đồng"
            style={{ width: '100%', height: '100%', border: 'none' }} />
        }
        {renderDialogCrup()}
      </Dialog>
      <Dialog header={`Mapping dữ liệu`} draggable={false} footer={fileFooter} visible={!!displayFormFields} style={{ width: '80rem', height: '60rem', }} position="top" onHide={() => setDisplayFormFields(false)}>
        {renderDataTableItem()}
      </Dialog>
    </Dialog>
  );
}
const DisplayCanvas = ({ inputFile, agreementData, loading, setLoading, agreementSignatureParties, setAgreementSignatureParties, agreementParties, useTemplate, deleteSignatureLocations, setDeleteSignatureLocations }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageCanvases, setPageCanvases] = useState([]);
  const canvasRefs = useRef([]);
  const nodeRef = useRef(null);

  const [signatureTypeEnums, setSignatureTypeEnums] = useState([]);
  const [selectedSignatureTypeEnums, setSelectedSignatureTypeEnums] = useState(null);
  const [selectedParty, setSelectedParty] = useState(null);
  useEffect(() => {
    CommonService.verificationType().then(data => {
      setSignatureTypeEnums(data.listData.map(item => {
        return { value: item.enumId, label: item.description }
      }))
    })
  }, [])

  useEffect(() => {
    if (agreementParties.length) {
      agreementParties.map(agreementParty => {
        agreementParty.value = `${agreementParty.partyId}-${agreementParty.roleTypeId}`
        if (agreementParty.roleTypeId === "PartyA") {
          agreementParty.label = `[Bên A] - ${agreementParty.partyName}`
        } else if (agreementParty.roleTypeId === "PartyB") {
          agreementParty.label = `[Bên B] - ${agreementParty.partyName}`
        }
        agreementSignatureParties.map(agreementSignatureParty => {
          if (agreementSignatureParty.partyId === agreementParty.partyId && agreementSignatureParty.roleTypeId === agreementParty.roleTypeId) {
            agreementSignatureParty.label = agreementParty.label
          }
        })
      })

    }
  }, [agreementParties])

  useEffect(() => {
    if (agreementData.agreementId && agreementSignatureParties.length === 0) {
      agreementData.agreementSignatureParties.map(item => {
        const x = item.ulx
        const y = item.uly
        const ulx = item.ulx
        const uly = item.uly
        const signatureTypeEnumId = item.signatureTypeEnumId;
        const partyId = item.partyId
        const pageHeight = item.pageHeight;
        const pageWidth = item.pageWidth;
        const dateTime = FormatDisplay.dateTime(item.lastUpdatedStamp)
        const fontSize = 12
        const pageIndex = item.pageNumber - 1
        const locationSeqId = item.locationSeqId
        const pageNumber = item.pageNumber
        const widthPx = item.widthPx
        const heightPx = item.heightPx
        let roleTypeId = ''
        let partyName = ''
        let label = ''
        agreementParties.map(agreementParty => {
          if (agreementParty.partyId === partyId) {
            roleTypeId = agreementParty.roleTypeId
            partyName = agreementParty.partyName
            label = agreementParty.label
          }
        })
        setAgreementSignatureParties((elements) => [
          ...elements,
          { id: elements.length, x, y, fontSize, locationSeqId, pageNumber, ulx, uly, label, pageIndex, dateTime, partyName, signatureTypeEnumId, pageHeight, pageWidth, partyId, widthPx, heightPx, roleTypeId },
        ]);
      })
    }
  }, [agreementData])
  useEffect(() => {
    if (inputFile && useTemplate === false) {
      if (agreementData?.agreementId) {
        const fetchPdfData = async () => {
          try {
            // Validate agreementContentId
            if (!agreementData?.agreementContentId) {
              ToastService.error('Không tìm thấy ID file hợp đồng.');
              setLoading(false);
              return;
            }

            const response = await fetch(`${Service.baseURL}/${Service.entity}/contents/${agreementData?.agreementContentId}/pdf`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
            });

            if (!response.ok) {
              ToastService.error(`Có lỗi xảy ra khi load PDF`)
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({ data: arrayBuffer });

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
                setLoading(false);
              });
            }, (reason) => {
              console.error('PDF loading failed:', reason);
              ToastService.error('Không thể tải PDF. Vui lòng kiểm tra file và thử lại.');
              setLoading(false);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
            ToastService.error('Có lỗi xảy ra khi tải file PDF. Vui lòng thử lại.');
            setLoading(false);
          }
        };

        fetchPdfData();
      } else {
        const reader = new FileReader();

        reader.onload = function () {
          try {
            const loadingTask = getDocument({ data: new Uint8Array(this.result as any) });

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
                setLoading(false);
              });
            }, (reason) => {
              console.error('PDF loading failed:', reason);
              ToastService.error('Không thể tải PDF. File có thể bị hỏng hoặc không đúng định dạng.');
              setLoading(false);
            });
          } catch (error) {
            console.error('Error processing PDF:', error);
            ToastService.error('Có lỗi xảy ra khi xử lý file PDF.');
            setLoading(false);
          }
        };

        reader.onerror = function () {
          console.error('FileReader error');
          ToastService.error('Không thể đọc file. Vui lòng thử lại.');
          setLoading(false);
        };

        reader.readAsArrayBuffer(inputFile);
      }
    } else if (useTemplate === true) {
      if (agreementData?.agreementId) {
        const fetchPdfData = async () => {
          try {
            const response = await fetch(`${Service.baseURL}/${Service.entity}/preview-by-template`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
              body: JSON.stringify(inputFile),
            });

            if (!response.ok) {
              ToastService.error(`Có lỗi xảy ra khi load PDF`)
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({ data: arrayBuffer });

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
                setLoading(false);
              });
            }, (reason) => {
              console.error(reason);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
          }
        };

        fetchPdfData();
      } else {
        const fetchPdfData = async () => {
          try {
            const response = await fetch(`${Service.baseURL}/${Service.entity}/preview-by-template`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
              body: JSON.stringify(inputFile),
            });
            if (!response.ok) {
              ToastService.error(`Có lỗi xảy ra khi load PDF`)
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({ data: arrayBuffer });

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
                setLoading(false);
              });
            }, (reason) => {
              console.error(reason);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
          }
        };

        fetchPdfData();
      }
    }
  }, [inputFile]);

  const renderPage = (pdf, pageNum) => {
    return pdf.getPage(pageNum).then((page) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      return page.render(renderContext).promise.then(() => canvas);
    });
  };

  const handleDrop = (event, pageIndex) => {
    const rect = canvasRefs.current[pageIndex].getBoundingClientRect();
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const cursorX = event.clientX - rect.left;
    const cursorY = event.clientY - rect.top;
    const ulx = event.clientX - rect.left;
    const uly = event.clientY - rect.top;
    const signatureTypeEnumId = selectedSignatureTypeEnums;
    const partyId = selectedParty.split("-")[0]
    const pageHeight = rect.height;
    const pageWidth = rect.width;
    const dateTime = FormatDisplay.dateTime(Date.now())
    const fontSize = 12
    let roleTypeId = ''
    let partyName = ''
    let label = ''
    let pageNumber = pageIndex + 1
    agreementParties.map(item => {
      if (item.value === selectedParty) {
        roleTypeId = item.roleTypeId
        partyName = item.partyName
        label = item.label
      }
    })
    const defaultWidth = 200;
    const defaultHeight = 65;
    const xMax = rect.width - defaultWidth;
    const yMax = rect.height - defaultHeight;
    const x = clamp(cursorX, 0, Math.max(0, xMax));
    const y = clamp(cursorY, 0, Math.max(0, yMax));

    setAgreementSignatureParties((elements) => [
      ...elements,
      { id: elements.length, x, y, ulx: x, uly: y, fontSize, label, pageNumber, pageIndex, dateTime, partyName, signatureTypeEnumId, pageHeight, pageWidth, partyId, widthPx: defaultWidth, heightPx: defaultHeight, roleTypeId },
    ]);
  };

  const handleDragStop = (event, data, elementId) => {
    const updatedElements = agreementSignatureParties.map((element) => {
      if (element.id === elementId) {
        const rect = canvasRefs.current[element.pageIndex].getBoundingClientRect();
        const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
        const maxX = rect.width - element.widthPx;
        const maxY = rect.height - element.heightPx;
        const nx = clamp(data.x, 0, Math.max(0, maxX));
        const ny = clamp(data.y, 0, Math.max(0, maxY));
        return {
          ...element,
          x: nx,
          y: ny,
          ulx: nx,
          uly: ny,
          pageNumber: element.pageIndex + 1
        };
      }
      return element;
    });
    setAgreementSignatureParties(updatedElements);
  };

  const removeElement = (elementId) => {
    const updatedElements = agreementSignatureParties.filter(element => element.id !== elementId);
    setDeleteSignatureLocations(agreementSignatureParties.filter(element => element.id === elementId))
    setAgreementSignatureParties(updatedElements);
    console.log(agreementSignatureParties)

  };
  const handleFormChange = (event, index) => {
    let data = [...agreementSignatureParties];
    data[index][event.target.name] = Number(event.target.value);
    setAgreementSignatureParties(data);
  }
  const handleDrag = (event, data, elementId) => {
    const updatedElements = agreementSignatureParties.map((element) => {
      if (element.id === elementId) {
        const rect = canvasRefs.current[element.pageIndex].getBoundingClientRect();
        const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
        const maxX = rect.width - element.widthPx;
        const maxY = rect.height - element.heightPx;
        const nx = clamp(data.x, 0, Math.max(0, maxX));
        const ny = clamp(data.y, 0, Math.max(0, maxY));
        return {
          ...element,
          x: nx,
          y: ny,
          ulx: nx,
          uly: ny,
          pageNumber: element.pageIndex + 1
        };
      }
      return element;
    });
  }
  return (
    <div>
      {!loading &&
        <div className={'flex'}>
          <div className={'col-3 card block'}>
            <div>
              {agreementData?.doView !== true &&
                <div className="flex flex-column gap-1 col-12">
                  <label htmlFor="partyId"><b>Chọn người ký</b></label>
                  <Dropdown style={{ width: '100%' }} optionLabel="label" options={agreementParties} value={selectedParty} onChange={(e) => setSelectedParty(e.value)} />
                </div>}
              <Divider type={'solid'} />
              {selectedParty && <span className="block font-medium mt-2"><b>(Chọn loại chữ ký và kéo thả vào vị trí cần ký)</b>
                {signatureTypeEnums.map((signatureTypeEnum, index) => (
                  <div
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.setData('text/plain', 'dragging');
                      setSelectedSignatureTypeEnums(signatureTypeEnum.value)
                    }}
                  >
                    {selectedParty && <Button icon={'pi pi-arrows-alt'} label={`${signatureTypeEnum.label}`} severity={'danger'} className={'mt-3 col-12'}></Button>}
                  </div>
                ))}
              </span>}
            </div>
            <div>
              {agreementSignatureParties.map((agreementSignatureParty, index) =>
              (
                <div className={'col-12'}>
                  <b style={{ fontSize: '14px' }}>Vị trí {index + 1}: {agreementSignatureParty.label}</b>

                  <div className={'flex'}>
                    <div className="flex flex-column col-4">
                      <label htmlFor="widthPx"><b>Chiều rộng</b></label>
                      <InputText id="widthPx" type={'number'} name={'widthPx'} value={agreementSignatureParty?.widthPx} onChange={event => handleFormChange(event, index)} />
                    </div>
                    <div className="flex flex-column col-4">
                      <label htmlFor="heightPx"><b>Chiều cao</b></label>
                      <InputText id="heightPx" type={'number'} name={'heightPx'} value={agreementSignatureParty?.heightPx} onChange={event => handleFormChange(event, index)} />
                    </div>
                    <div className="flex flex-column col-4">
                      <label htmlFor="fontSize"><b>Cỡ chữ</b></label>
                      <InputText id="fontSize" type={'number'} name={'fontSize'} value={agreementSignatureParty?.fontSize} onChange={event => handleFormChange(event, index)} />
                    </div>
                    <div>
                      <Button icon="pi pi-times" text outlined severity="danger" onClick={() => removeElement(agreementSignatureParty.id)} />
                    </div>

                  </div>
                </div>
              ))
              }
            </div>
          </div>
          <div className={'col-9 align-items-center justify-content-centers'} style={{ backgroundColor: 'whitesmoke', height: 'calc(100vh - 220px)' }}>
            <div>
              {pageCanvases.length > 0 && (
                <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 240px)' }}>
                  {pageCanvases.map((canvas, index) => (

                    <div
                      key={index}
                      style={{ position: 'relative', marginBottom: '20px' }}
                      onDrop={(event) => handleDrop(event, index)}
                      onDragOver={(event) => event.preventDefault()}
                    >

                      <canvas ref={ref => {
                        if (ref) {
                          ref.replaceWith(canvas);
                          canvasRefs.current[index] = canvas;
                        }
                      }}></canvas>

                      {agreementSignatureParties
                        .filter(element => element.pageIndex === index)
                        .map((element) => (

                          <Draggable
                            nodeRef={nodeRef}
                            key={element.id}
                            defaultPosition={{ x: element.x, y: element.y }}
                            bounds={{
                              left: 0,
                              top: 0,
                              right: Math.max(0, canvas.width - element.widthPx),
                              bottom: Math.max(0, canvas.height - element.heightPx)
                            }}
                            disabled={agreementData?.doView === true}
                            onDrag={(e, data) => handleDrag(e, data, element.id)}
                            onStop={(event, data) => handleDragStop(event, data, element.id)}
                          >
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              background: 'rgb(255,255,255)',
                              padding: '5px',
                              borderRadius: '5px',
                              cursor: 'move',
                              borderColor: 'red',
                              borderStyle: 'dashed',
                              height: element.heightPx,
                              width: element.widthPx
                            }} ref={nodeRef} className={'flex'}>
                              <div ref={nodeRef} className={'col-11'} style={{ fontSize: element.fontSize, padding: 0 }}>
                                -Ký bởi: {element.partyName}<br />
                                - Ký ngày: dd/MM/yyyy
                              </div>
                            </div>
                          </Draggable>
                        ))}
                    </div>
                  ))}
                </ScrollPanel>
              )}
            </div>
          </div>
        </div>}
    </div>
  )
}

const AgreementParties = ({ agreementParties, setAgreementParties, agreementData, deleteAgreementParties, setDeleteAgreementParties }) => {
  const [agreementRoleTypes, setAgreementRoleTypes] = useState([]);
  const [customers, setCustomers] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [partyTax, setPartyTax] = useState(null);
  const [partyNameNew, setPartyNameNew] = useState('');
  const [partyPhone, setPartyPhone] = useState('');
  const [provinces, setProvinces] = useState([]);
  const [counties, setCounties] = useState([]);
  const [party, setParty] = useState(null)
  const [activeIndex, setActiveIndex] = useState(null)
  useEffect(() => {
    CommonService.getProvinces().then(({ listData }) => {
      setProvinces(listData.map(item => {
        return { value: item?.toGeoId, label: item?.geoName }
      }))
    })
  }, []);

  useEffect(() => {
    if (agreementData?.doView === true) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [agreementData])
  useEffect(() => {
    if (agreementParties) {
      CommonService.agreementRoleTypes().then(data => {
        setAgreementRoleTypes(data.listData.map(item => {
          return { value: item.roleTypeId, label: item.description }
        }))
        CustomerService.find('').then(data => {
          setCustomers(data.listData.map(item => {
            delete item.disabled;
            let label = `[${item.pseudoId}] - ${item.partyName}`;
            return { ...item, value: item.partyId, label: label };
          }));
        });
      })
    }
  }, [agreementParties])
  useEffect(() => {
    if (party) {
      CustomerService.find('').then(data => {
        data.listData.map(async item => {
          delete item.disabled;
          if (item.partyId === party) {
            let label = `[${item.pseudoId}] - ${item.partyName}`;

            // Create a copy of agreementParties to update
            const updatedParties = [...agreementParties];
            updatedParties[activeIndex].party = { value: party, label: label }

            await CustomerService.get(party).then(customer => {
              updatedParties[activeIndex].taxCode = customer.partyTaxId || ''
              updatedParties[activeIndex].partyName = customer.partyName || ''
              updatedParties[activeIndex].emailAddress = customer.emailAddress || ''
              updatedParties[activeIndex].contactNumber = customer.contactNumber || ''
              updatedParties[activeIndex].representativeName = customer.representativeName || ''
              updatedParties[activeIndex].partyId = party

              // Update the state to trigger re-render
              setAgreementParties(updatedParties)
            })
          }
        })
      })
    }
  }, [party])
  const searchCustomers = event => {
    CustomerService.find(event.query).then(data => {
      setCustomers(data.listData.map(item => {
        delete item.disabled;
        return { ...item, value: item.partyId, label: `[${item.pseudoId}] - ${item.partyName}` };
      }))
    })
  }

  const handleFormChange = async (event, index) => {
    let data = [...agreementParties];
    
    // Validation cho mã số thuế - chỉ cho phép nhập số
    if (event.target.name === 'taxCode') {
      const taxCode = event.target.value;
      // Chỉ cho phép nhập số
      if (!/^\d*$/.test(taxCode)) {
        return; // Không cập nhật giá trị nếu không phải số
      }
    }
    
    data[index][event.target.name] = event.target.value;
    
    if (event.target.name === 'partyId') {
      data[index]['party'] = event.target.value
      if (event.target.value.partyId) {
        await CustomerService.get(event.target.value.partyId).then(customer => {
          data[index].taxCode = customer.partyTaxId || ''
          data[index].partyName = customer.partyName || ''
          data[index].emailAddress = customer.emailAddress || ''
          data[index].contactNumber = customer.contactNumber || ''
          data[index].representativeName = customer.representativeName || ''
          data[index].identityCard = customer.idValue || ''
          data[index].partyId = event.target.value.partyId
        })
      }

    }
    setAgreementParties(data);
  }
  const submit = (e) => {
    e.preventDefault();
  }
  const addFields = () => {
    let object = {
      party: null,
      partyId: '',
      taxCode: '',
      partyName: '',
      emailAddress: '',
      contactNumber: '',
      representativeName: '',
      identityCard: '',
      roleTypeId: ''
    }
    setAgreementParties([...agreementParties, object])
  }
  const removeFields = (index) => {
    let data = [...agreementParties];
    const removed = data.splice(index, 1)
    deleteAgreementParties.push(removed[0])
    setAgreementParties(data)
  }
  const createCustomer = (index) => {
    setActiveIndex(index)
    formRepresentative.reset();
    setPartyTax(null);
    create({ partyTypeEnumId: 'PtyOrganization' })
  }
  const inject = (item) => {
    item = { ...item, ..._valueFormRep }
    item.partyTaxId = partyTax;
    return item
  }
  const doGetPartyByTax = (partyTaxId) => {
    CommonService.getPartyByTax(partyTaxId).then(({ data }) => {
      const newValue = { ..._fromValue, ...data, ..._valueFormRep };
      formRepresentative.setValue(newValue);
      form.setValue(newValue)
    })
  }
  const formRepresentative = useForm({
    fields: [
      { field: 'representativeName', header: 'Tên người đại diện', className: 'md:col-6' },
      { field: 'representativeJobTitle', header: 'Chức vụ người đại diện', className: 'md:col-6' }
    ],
  })

  const { render: renderDialogCrup, create, form } = useDialogCrup({
    header: 'khách hàng',
    dataKey: 'partyId',
    width: '80rem',
    fields: [
      { field: 'pseudoId', header: 'Mã khách hàng', required: true, className: 'md:col-3' },
      { field: 'partyTypeEnumId', header: 'Loại khách hàng', required: true, className: 'md:col-3', type: 'Dropdown', DropdownProps: { options: partyTypes } },
      { field: 'partyName', header: 'Tên khách hàng', required: true, className: 'md:col-6', type: 'custom', body: <Fragment>
        <label>Tên khách hàng</label>
        <InputText 
          value={partyNameNew}
          onInput={(e) => {
            const inputEl = e.target as HTMLInputElement;
            const value = inputEl.value.replace(/[^a-zA-ZÀ-ỹ\s-]/g, '');
            inputEl.value = value;
            setPartyNameNew(value);
          }}
          onChange={(e) => setPartyNameNew((e.target as HTMLInputElement).value)}
          pattern="[a-zA-ZÀ-ỹ\s-]+"
          title="Chỉ được nhập chữ cái và khoảng trắng"
        />
      </Fragment> },
      {
        field: 'partyTaxId', header: 'Mã số thuế', className: 'md:col-3', type: 'custom', body: <Fragment>
          <label>Mã số thuế</label>
          <div className="p-inputgroup flex-1">
            <InputText 
              value={partyTax} 
              onChange={(e) => {
                const value = e.target.value;
                // Chỉ cho phép nhập số
                if (!/^\d*$/.test(value)) {
                  return; // Không cập nhật giá trị nếu không phải số
                }
                setPartyTax(value);
              }}
              onKeyPress={(e) => {
                // Chỉ cho phép nhập số
                if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                  e.preventDefault();
                }
              }}
              onInput={(e) => {
                // Xóa ký tự không phải số
                const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                if (value !== (e.target as HTMLInputElement).value) {
                  (e.target as HTMLInputElement).value = value;
                  setPartyTax(value);
                }
              }}
              onPaste={(e) => {
                // Ngăn paste nếu có ký tự không phải số
                const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                if (!/^[0-9]*$/.test(paste)) {
                  e.preventDefault();
                }
              }}
              maxLength={13}
              pattern="[0-9]*"
              inputMode="numeric"
            />
            <span className="p-inputgroup-addon">
              <Button icon="pi pi-search" className="p-button-info" size="small" onClick={() => doGetPartyByTax(partyTax)} />
            </span>
          </div>
        </Fragment>
      },
      { 
        field: 'contactNumber', 
        header: 'Số điện thoại', 
        className: 'md:col-3',
        type: 'custom',
        body: <Fragment>
          <label>Số điện thoại</label>
          <InputText 
            value={partyPhone}
            maxLength={10}
            onInput={(e) => {
              const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
              (e.target as HTMLInputElement).value = value;
              setPartyPhone(value);
            }}
            onPaste={(e) => {
              const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
              if (!/^[0-9]*$/.test(paste)) {
                e.preventDefault();
              }
            }}
            inputMode="numeric"
          />
        </Fragment>
      },
      { field: 'bankName', header: 'Tên ngân hàng', className: 'md:col-3' },
      { field: 'accountNumber', header: 'Số tài khoản', className: 'md:col-3' },
      {
        field: 'idValue', header: 'Số CCCD/CMND', className: 'md:col-3', disabledDependency(item: any): boolean {
          return item.partyTypeEnumId === 'PtyOrganization';
        }
      },
      { field: 'emailAddress', header: 'Địa chỉ email', className: 'md:col-3' },
      { field: 'stateProvinceGeoId', header: 'Tỉnh/Thành phố', className: 'md:col-3', type: 'Dropdown', DropdownProps: { options: provinces } },
      { field: 'countyGeoId', header: 'Quận/Huyện', className: 'md:col-3', type: 'Dropdown', DropdownProps: { options: counties } },
      { field: 'address1', header: 'Địa chỉ', className: 'md:col-12' },
      {
        type: 'custom', className: 'md:col-12', displayDependency(item: any): boolean {
          return item.partyTypeEnumId === 'PtyOrganization'
        }, body: <Fieldset legend="Người đại diện">
          {formRepresentative.render()}
        </Fieldset>
      }
    ],
    createItem(item: any): Promise<any> {
      // Áp tên khách hàng đã lọc
      if (partyNameNew) {
        item.partyName = partyNameNew;
      }
      // Validation mã số thuế trước khi tạo khách hàng
      if (partyTax && partyTax.length > 0 && ![10, 12, 13].includes(partyTax.length)) {
        ToastService.error('Mã số thuế phải có 10, 12 hoặc 13 số');
        return Promise.reject('Invalid tax code length');
      }
      
      // Validation số điện thoại trước khi tạo khách hàng: đúng 10 số
      if (item.contactNumber && item.contactNumber.length > 0 && item.contactNumber.length !== 10) {
        ToastService.error('Số điện thoại phải có đúng 10 số');
        return Promise.reject('Invalid phone number length');
      }
      
      return CustomerService.create(inject(item)).then(data => {
        setParty(data.partyId)

        // Refresh customers list to include the new customer
        CustomerService.find('').then(customerData => {
          const newCustomers = customerData.listData.map(customer => {
            delete customer.disabled;
            let label = `[${customer.pseudoId}] - ${customer.partyName}`;
            return { ...customer, value: customer.partyId, label: label };
          });
          setCustomers(newCustomers);

          // Auto-select the newly created customer
          const newCustomer = newCustomers.find(customer => customer.partyId === data.partyId);
          if (newCustomer && activeIndex !== null) {
            const updatedParties = [...agreementParties];
            updatedParties[activeIndex].party = { value: newCustomer.partyId, label: newCustomer.label };
            setAgreementParties(updatedParties);
          }
        });
      })
    },
  })
  const _valueFormRep = formRepresentative.getRawValue()
  const _fromValue = form.getRawValue()
  const { stateProvinceGeoId } = form.getRawValue()

  useEffect(() => {
    if (stateProvinceGeoId) {
      CommonService.getCounties(stateProvinceGeoId).then(({ listData }) => {
        setCounties(listData.map(item => {
          return { value: item?.toGeoId, label: item?.geoName }
        }))
      })
    }
  }, [stateProvinceGeoId]);

  const itemTemplate = (item) => {
    return (
      <div className="flex align-items-center">
        <div>{item.label}</div>
      </div>
    );
  };

  return (<div className={'grid mt-3'}>
    <div className={'col-12 flex justify-content-between flex-wrap'}>
      {!disabled && <b style={{ fontSize: '20px' }}>Người nhận</b>}
    </div>
    <div className={'col-12'}>
      <form onSubmit={submit}>
        {agreementParties.map((form, index) => {
          customers.map(customer => {
            if (customer?.partyId === form?.partyId) {
              form.party = { value: customer.value, label: customer.label }
            }
          })
          return (
            <div className={'col-12 card'} style={{ padding: '0.5rem' }} key={index}>
              <div className="flex col-12">
                <div className="col-3 flex flex-column">
                  <label htmlFor="partyId"><b>Đối tượng</b> <span style={{ color: 'red' }}>*</span></label>
                  <div className={'p-inputgroup mt-2'} style={{ height: '34px' }}>
                    <AutoComplete dropdown disabled={disabled} field={'label'} itemTemplate={itemTemplate} completeMethod={searchCustomers} name={'partyId'} id={'partyId'} suggestions={customers} value={form?.party} onChange={(event) => handleFormChange(event, index)} />
                    <span className="p-inputgroup-addon" style={{ background: '#22C55E', color: 'white', cursor: 'pointer' }} onClick={() => createCustomer(index)}>
                      <i className="pi pi-plus" />
                    </span>
                  </div>
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="taxCode"><b>Mã số thuế</b></label>
                  <InputText 
                    disabled={disabled} 
                    id="taxCode" 
                    name={'taxCode'} 
                    value={form?.taxCode} 
                    onChange={event => handleFormChange(event, index)}
                   
                    onInput={(e) => {
                      // Xóa ký tự không phải số
                      const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                      if (value !== (e.target as HTMLInputElement).value) {
                        (e.target as HTMLInputElement).value = value;
                        handleFormChange({ target: { name: 'taxCode', value } }, index);
                      }
                    }}
                    onPaste={(e) => {
                      // Ngăn paste nếu có ký tự không phải số
                      const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                      if (!/^[0-9]*$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={13}
                    pattern="[0-9]*"
                    inputMode="numeric"
                  />
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="partyName"><b>Tên công ty</b></label>
                  <InputText 
                    disabled={disabled} 
                    id="partyName" 
                    name={'partyName'} 
                    value={form?.partyName} 
                    onInput={(e) => {
                      const inputEl = e.target as HTMLInputElement;
                      const value = inputEl.value.replace(/[^a-zA-ZÀ-ỹ\s-]/g, '');
                      if (value !== inputEl.value) inputEl.value = value;
                    }}
                    onChange={event => handleFormChange(event, index)} 
                    pattern="[a-zA-ZÀ-ỹ\s-]+" 
                    title="Chỉ được nhập chữ cái và khoảng trắng" 
                  />
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="emailAddress"><b>Email</b> <span style={{ color: 'red' }}>*</span></label>
                  <InputText disabled={disabled} id="emailAddress" name={'emailAddress'} value={form?.emailAddress} onChange={event => handleFormChange(event, index)} />
                </div>
              </div>
              <div className="flex col-12">
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="contactNumber"><b>Số điện thoại</b></label>
                  <InputText 
                    disabled={disabled} 
                    id="contactNumber" 
                    name={'contactNumber'} 
                    value={form?.contactNumber} 
                    onInput={(e) => {
                      const value = (e.target as HTMLInputElement).value.replace(/[^0-9]/g, '');
                      (e.target as HTMLInputElement).value = value;
                      handleFormChange({ target: { name: 'contactNumber', value } }, index);
                    }}
                    onPaste={(e) => {
                      const paste = (e.clipboardData || (window as any).clipboardData).getData('text');
                      if (!/^[0-9]*$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                    pattern="[0-9]*"
                    inputMode="numeric"
                  />
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="representativeName"><b>Họ và Tên</b></label>
                  <InputText disabled={disabled} id="representativeName" name={'representativeName'} value={form?.representativeName} onChange={event => handleFormChange(event, index)} pattern="[a-zA-ZÀ-ỹ\s]+" title="Chỉ được nhập chữ cái và khoảng trắng" />
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="identityCard"><b>CCCD/CMND</b></label>
                  <InputText disabled={disabled} id="identityCard" name={'identityCard'} value={form?.identityCard} onChange={event => handleFormChange(event, index)} />
                </div>
                <div className="flex flex-column gap-2 col-3">
                  <label htmlFor="roleTypeId"><b>Vai trò</b> <span style={{ color: 'red' }}>*</span></label>
                  <Dropdown disabled={disabled} id="roleTypeId" name={'roleTypeId'} options={agreementRoleTypes} value={form?.roleTypeId} onChange={event => handleFormChange(event, index)} />
                </div>
              </div>
              {!disabled && <Button className={'mt-1'} size={'small'} onClick={() => removeFields(index)} icon={'pi pi-trash'} label={'Xóa'} severity={'danger'} disabled={agreementParties.length === 1}></Button>}
            </div>
          )
        })}
      </form>
    </div>
    {!disabled && <div className={'col-12 flex'}>
      <Button icon={'pi pi-plus'} size={'small'} label={'Thêm người nhận'} onClick={() => addFields()}> </Button>
    </div>}
    {renderDialogCrup()}
  </div>
  )
}
const steps = [
  {
    label: 'Tải hợp đồng mẫu',
  },
  {
    label: 'Khai báo người nhận',
  },
  {
    label: 'Thiết lập vị trí',
  },
];
const partyTypes = [
  { value: 'PtyOrganization', label: 'Tổ chức' },
  { value: 'PtyPerson', label: 'Cá nhân' }
]